module.exports = __webpack_public_path__ + "static/media/loc1_img5.9bdb331d.jpg";